import { lazy } from "react";

// After a new deploy, react-scripts emits fresh content-hashed chunk files and
// the old ones disappear from the server. A tab left open (or a stale cached
// index.html) then tries to lazy-load a chunk that 404s, throwing
// "Loading chunk X failed". Force a single reload to pick up the new build
// instead of leaving the user stuck on the error.
export function lazyWithRetry(componentImport) {
  return lazy(async () => {
    const hasRefreshed = JSON.parse(
      window.sessionStorage.getItem("chunk-load-refreshed") || "false"
    );

    try {
      const component = await componentImport();
      window.sessionStorage.setItem("chunk-load-refreshed", "false");
      return component;
    } catch (error) {
      if (!hasRefreshed) {
        window.sessionStorage.setItem("chunk-load-refreshed", "true");
        window.location.reload();
        return new Promise(() => {});
      }
      throw error;
    }
  });
}
